import { useState, useEffect } from 'react';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { TextField } from '@mui/material';
import OutlinedDiv from '../layout/OutlinedDiv';
import { FormatHTMLForWYSIWYGEditor } from '../../services/utilities';
import apiAdmin from '../../services/api-admin';

const CommunityEventDetails = ({ onSectionsChange, initialSections }) => {
    const [sections, setSections] = useState(
        (initialSections || []).map(section => ({
            ...section,
            editorState: FormatHTMLForWYSIWYGEditor(section.eventDetail)
        }))
    );

    useEffect(() => {
        onSectionsChange(sections);
    }, [sections, onSectionsChange]);

    const addSection = () => {
        setSections([...sections, { title: '', editorState: EditorState.createEmpty() }]);
    };

    const deleteSection = async (index, detailId) => {
        setSections(sections.filter((_, i) => i !== index));
        await apiAdmin.delete(`/delete-community-event-detail?eventDetailId=${detailId}`);
    };

    const handleTitleChange = (index, event) => {
        const newSections = [...sections];
        newSections[index].title = event.target.value;
        setSections(newSections);
    };

    const handleEditorChange = (index, editorState) => {
        const newSections = [...sections];
        newSections[index].editorState = editorState;
        setSections(newSections);
    };

    return (
        <div>
            {sections && sections.map((section, index) => (
                <div key={index} className="mb-3">
                    <TextField
                        label={`Section ${index + 1} Title`}
                        value={section.title}
                        onChange={(e) => handleTitleChange(index, e)}
                        className="w-100 mb-3"
                    />
                    <OutlinedDiv label={`Section ${index + 1} Editor`}>
                        <small> Please paste plain text only.</small>
                        <Editor
                            editorState={section.editorState}
                            editorClassName="wysiwyg-editor"
                            onEditorStateChange={(e) => handleEditorChange(index, e)}
                        />
                    </OutlinedDiv>
                    <button
                        type="button"
                        className="btn btn-primary my-1 float-end"
                        onClick={() => deleteSection(index, section.detailId)} 
                    >
                        Delete Section
                    </button>
                </div>
            ))}
            <button type="button" className="btn btn-primary" onClick={addSection}>Add Custom Section</button>
        </div>
    );
};

export default CommunityEventDetails;